export default __webpack_public_path__ + "static/media/home-slider2.4be346b7.svg";